// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2jlS_","type":"styles_type__2qMvg","choices":"styles_choices__YPQTx"};